// Firebase SDK 불러오기
import { initializeApp, getApp, getApps } from 'firebase/app';
import { getAuth, initializeAuth, indexedDBLocalPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// 환경 감지: REACT_APP_ENV=production이면 프로덕션 Firebase 사용
const currentUrl = window.location.hostname;
const forceProduction = process.env.REACT_APP_ENV === 'production';
let firebaseConfig;

if (!forceProduction && (currentUrl.includes('whatquiztest') || currentUrl.includes('localhost'))) {
  // 테스트 환경 설정
  firebaseConfig = {
    apiKey: "AIzaSyCkeP2ITtAZQXMQNksPSrzH1yr9uBO9n24",
    authDomain: "whatquiztest-c584b.firebaseapp.com",
    projectId: "whatquiztest-c584b",
    storageBucket: "whatquiztest-c584b.firebasestorage.app",
    messagingSenderId: "844100436462",
    appId: "1:844100436462:web:78140103c9207bbc354eff",
    measurementId: "G-L3DGNHLY96"
  };
} else if (currentUrl.includes('whatquiz.co.kr')) {
  // 새 프로덕션 도메인 설정
  firebaseConfig = {
    apiKey: "AIzaSyBgbxRRw4RTaJxwPWCkfEV0l-CeeJqyiGA",
    authDomain: "whatquiz.co.kr",
    projectId: "whatquiz-bd17e",
    storageBucket: "whatquiz-bd17e.firebasestorage.app",
    messagingSenderId: "397277209875",
    appId: "1:397277209875:web:68bfeccfac23874775a6e6",
    measurementId: "G-XRTB5FR027"
  };
} else {
  // 기존 프로덕션 환경 설정 (fallback)
  firebaseConfig = {
    apiKey: "AIzaSyBgbxRRw4RTaJxwPWCkfEV0l-CeeJqyiGA",
    authDomain: "whatquiz-bd17e.firebaseapp.com",
    projectId: "whatquiz-bd17e",
    storageBucket: "whatquiz-bd17e.firebasestorage.app",
    messagingSenderId: "397277209875",
    appId: "1:397277209875:web:68bfeccfac23874775a6e6",
    measurementId: "G-XRTB5FR027"
  };
}

// Firebase 초기화 (이미 초기화되어 있으면 기존 인스턴스 재사용 - HMR 안전)
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

// Auth 인스턴스 초기화
// - 모바일 앱(Capacitor iOS/Android): indexedDBLocalPersistence 명시 지정
//   (WKWebView/Capacitor WebView에서 기본 sessionStorage가 격리되어 로그인 상태 유실 방지)
// - 일반 웹: 기존 getAuth() 그대로 사용 (Firebase 기본 persistence 적용)
const isCapacitorNative = typeof window !== 'undefined'
  && !!window.Capacitor
  && typeof window.Capacitor.isNativePlatform === 'function'
  && window.Capacitor.isNativePlatform();

let authInstance;
try {
  authInstance = isCapacitorNative
    ? initializeAuth(app, { persistence: indexedDBLocalPersistence })
    : getAuth(app);
} catch (e) {
  // initializeAuth는 동일 app 인스턴스에 대해 한 번만 호출 가능 → HMR 두 번째 호출 등에서 fallback
  authInstance = getAuth(app);
}

export const auth = authInstance;

// Firestore 인스턴스 내보내기
export const db = getFirestore(app);

// Storage 인스턴스 내보내기
export const storage = getStorage(app);

export default app;